import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet } from "auth/useApi2"
import Button from "components/Button"
import ClpTable from "components/ClpTable"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import moment from "moment"
import { useContext, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Link, useHistory } from "react-router-dom"
import { StyledTableContainer } from "shared/styled/Global"

const Storage = () => {
  const { t } = useTranslation()
  const routerHistory = useHistory()

  const [storageResult, getStorage] = useApiGet()
  const loadingContext = useContext(GlobalLoaderContext)

  useEffect(() => {
    getStorage(apiEndpoints.systemadmindeviceregistry.liststorages)
  }, [getStorage])

  useEffect(() => {
    loadingContext.setLoading(() => storageResult.status === 1)
  })
  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: t("global.name", "Name")
      },
      {
        accessorKey: "companyName",
        header: t("global.company", "Company")
      },
      {
        accessorKey: "equipmentCount",
        header: t("sysadmin.number_of_connected_devices", "Number of connected devices")
      },
      {
        accessorFn: (row) => {
          return row.created ? moment(row.created).format("YYYY-MM-DD hh:mm") : ""
        },
        header: t("global.created", "Created")
      }
    ],
    []
  )

  return (
    <div>
      <Container>
        <Box>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h1">{t("sysadmin.warehouse_location", "Storage locations")}</Typography>
            <Button
              component={Link}
              to={allRoutes.SystemadminDevicesStorageAdd()}
              color="primary"
              variant="contained">
              {t("sysadmin.add_warehouse_location", "Add storage location")}
            </Button>
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          columns={columns}
          onRowClick={(row) => routerHistory.push(allRoutes.SystemadminDevicesStorageEdit(row.original.id))}
          rows={storageResult.status === 2 && storageResult.data}
          loadingState={storageResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}

export default Storage
